import { ceilRequirement, type RoundedRequirement } from './rounding';

export type ReverseEdgeStatus = 'ok' | 'unreachable' | 'unresolved';

export interface ReverseThroughEdgeResult {
  status: ReverseEdgeStatus;
  requiredSourceExits: number | null;
  rounding?: RoundedRequirement;
}

/**
 * SPEC-009 §23/§27/§30/plan §21 — reverse through one specific edge:
 * `requiredSourceExits = ceil(requiredFlow / edgeConversion)`. Other
 * outgoing edges from the same source are not accounted for here — they
 * are separate consequences (§30), not this edge's requirement.
 */
export function reverseThroughEdge(requiredFlow: number, edgeConversion: number | null): ReverseThroughEdgeResult {
  if (edgeConversion === null) {
    return { status: 'unresolved', requiredSourceExits: null };
  }
  if (edgeConversion === 0) {
    return requiredFlow > 0
      ? { status: 'unreachable', requiredSourceExits: null }
      : { status: 'ok', requiredSourceExits: 0, rounding: ceilRequirement(0) };
  }
  const rounding = ceilRequirement(requiredFlow / edgeConversion);
  return { status: 'ok', requiredSourceExits: rounding.roundedRequired, rounding };
}
